import React from 'react';
import '../Popup.scss';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

class Popup extends React.Component {
  onClickDelete = (e, id) => {
    const { handleClickDelete, handleClickClose } = this.props;
    handleClickClose();
    handleClickDelete(e, id);
  };

  render() {
    const { textContent, handleClickClose, title, id } = this.props;
    return (
      <div className="popup_inner">
        <span className="warn warning" />
        <span className="popup_inner_title">{I18n.t(title)}</span>
        <span className="popup_inner_content">{I18n.t(textContent)}</span>
        <div className="popup-button mt-5">
          <button
            onClick={e => this.onClickDelete(e, id)}
            className="btn-delete text-uppercase mr-5"
          >
            {I18n.t('common.button.delete')}
          </button>
          <button
            className="btn-cancel text-uppercase"
            onClick={handleClickClose}
          >
            {I18n.t('common.button.cancel')}
          </button>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  i18n: state.i18n,
});

export default connect(mapStateToProps)(Popup);
